<template>
    <div class="eco-content-space h100 overflow-y-auto">
        <div class="white-box">
            <client-stats></client-stats>
        </div>
    </div>
</template>

<script>
    import ClientStats from '@/components/global/stats/ClientStats.vue';

    export default {
        name: "DashboardAdmin",
        components: {
            ClientStats,
        },
        computed: {
            masterAgencies() {
                let rows = this.$store.state.masterAgencies;
                let valid = rows.filter((item) => {
                    return !item.attributes.core;
                });

                return valid;
            },
            userCompany() {
                return this.$store.state.userCompany;
            },
            isAdmin() {
                return this.$store.state.user.attributes.isAdmin;
            },
            tableRows() {
                let rows = this.$store.state.agencyClients;
                if( this.$store.state.userCompany
                    && this.$store.state.userCompany.attributes.isAgency
                    && !this.$store.state.userCompany.attributes.core
                ){
                    rows.push(this.$store.state.userCompany)
                }

                let suspended = rows.filter((item) => {
                    return item.attributes.suspended;
                });

                let active = rows.filter((item) => {
                    return !item.attributes.suspended;
                });

                return this.showSuspended ? suspended : active;
            },
            selectedRowsTrue() {
                let selected = [];
                for (const key in this.selectedRows) {
                    if (this.selectedRows[key]) {
                        selected.push(key);
                    }
                }
                return selected;
            }
        },
        data() {
            return {
                selectedAgency: null,
                perPageOptions: [
                    {
                        value: 10,
                        text: 10
                    },
                    {
                        value: 25,
                        text: 25
                    },
                    {
                        value: 50,
                        text: 50
                    },
                    {
                        value: 100,
                        text: 100
                    },
                ],
                perPageValue: 25,
                selectedRows: {},
                sharing: false,
                wizzardOpened: true,
                searchString: null,
                timeout: null,
                showSuspended: false,
                checkingAgencies: false,
            }

        },
        mounted() {
            this.$store.dispatch('getCompany').then((userCompany) => {
                    if(userCompany.attributes.core){
                        this.checkingAgencies = true;
                        this.$store.dispatch('getAllAgencies')
                    }else {
                        this.$store.dispatch('getCardTemplates');
                        this.$store.dispatch('getAgencyClients');
                    }
            });
            this.$store.commit('closeRightModal');
        },
        methods: {
            showClients(item){
                this.selectedAgency = item;
                this.$store.dispatch('getAgencyClients', {clientOf:item})
            },
            calculateCards(item) {
                return item.attributes.currentCardCount ? item.attributes.currentCardCount : 0;
            },
            calculateAgencyCards(item){
                let total = 0;
                if(item.attributes.relatedCompanies){
                    item.attributes.relatedCompanies.forEach((client) => {
                        if(client.attributes.currentCardCount){
                            total += client.attributes.currentCardCount;
                        }
                    })
                }
                return total;
            },
            clearSelectedAgency(){
                this.selectedAgency = null;
                this.checkingAgencies = true;
                this.$store.dispatch('getAllAgencies')
            },
            computeStatus(item){
                let output = {
                    text: '',
                    color: '',
                    icon: 'check'
                };

                let company = item;
                let cardCount = company.attributes.currentCardCount;
                let users = company.attributes.relatedUsers ? company.attributes.relatedUsers : [];
                let cardConfig = company.attributes.relatedCardConfig ? company.attributes.relatedCardConfig : null;

                let hasDesign = (cardConfig && cardConfig.attributes.designVer > 1);
                let hasUsers = (users.length > 0);
                let hasCards = (cardCount > 0);

                if(!hasCards && !hasUsers &&  !hasDesign){
                    output.text = 'New';
                    output.color = 'blue';
                    output.icon = 'star';
                }else if(!hasDesign){
                    output.text = 'Missing design';
                    output.color = 'error';
                    output.icon = 'palette';

                } else if (!hasUsers) {
                    output.text = 'No user assigned';
                    output.color = 'primary';
                    output.icon = 'user';
                } else if (!hasCards) {
                    output.text = 'Ready to onboard';
                    output.color = 'dark';
                    output.icon = 'calendar';
                } else {
                    output.text = 'Active';
                    output.color = 'secondary';
                    output.icon = 'check';
                }

                return output;
            },

            showAgencyClients(item){
                this.selectedAgency = item;
                this.checkingAgencies = false;
                this.$store.dispatch('getAgencyClients', {clientOf:item})
            },

            extractPromo(item) {
                if (item.attributes.usedPromo
                    && item.attributes.usedPromo.attributes
                    && item.attributes.usedPromo.attributes.code
                ) {
                    return item.attributes.usedPromo.attributes.code;
                } else {
                    return '';
                }
            },

            doSearch(searchString){
                this.$store.dispatch('getAgencyClients', {searchTerm : searchString})
            },
            suspendedRow(item){
                if(this.isSuspended(item)){
                    return 'suspended';
                }else{
                    return '';
                }
            },
            copySelfOnboardLink(item){

                let invitationLink = window.location.protocol + '//' + window.location.host
                    +'/addme/'+item.id+'/'+item.attributes.frameSecret;

                navigator.clipboard.writeText(invitationLink);

                this.$notify({
                    group: 'notification',
                    type: 'success',
                    text: this.$ml.get('notification_onboard_link_copied')
                });

            },
            suspendMesssage(item){
                if(this.isSuspended(item)){
                    return this.$ml.get('RESTORE_CLIENT');
                }else {
                    return this.$ml.get('SUSPEND_CLIENT');
                }
            },
            isSuspended(item){
                return item.attributes.suspended;
            },
            suspendClient(id){
                this.$store.commit('toggleDashboardModal', {name: 'DashboardClientSuspend', data: {ids: [id]}})
            },
            forbidDelete(item){
                return item.attributes.isAgency;
            },
            forbidAgencyDelete(item){
                return item.attributes.relatedCompanies.length > 0;
            },
            toggleModal(componentName) {
                this.$store.commit('toggleDashboardModal', {name: componentName})
            },
            addNewClient(){
                this.$router.push({name: 'client-add'});
            },
            editAgencySettings(id = null) {
                this.$store.commit('toggleDashboardModal', {name: 'DashboardAgencySettingsForm', data: {id: id}})
            },
            editClient(id = null) {
                this.$store.commit('toggleDashboardModal', {name: 'DashboardClientsForm', data: {id: id}})
                this.wizzardOpened = true;
            },
            deleteClient(id, isAgency = false) {
                // DashboardEmployeeCardsDelete
                this.$store.commit('toggleDashboardModal', {name: 'DashboardClientsDelete', data: {ids: [id], isAgency: isAgency}})
            },
            bulkDelete() {
                this.$store.commit('toggleDashboardModal', {
                    name: 'DashboardClientsDelete',
                    data: {ids: this.selectedRowsTrue}
                })
            },
            goToClientCards(clientCompany) {
                let self = this;
                this.$store.dispatch('changeImpersonation', clientCompany).then(function(response){
                    if(response.attributes.impersonating){
                        self.$notify({
                            group: 'notification',
                            type: 'success',
                            text: "Switching to managing "+clientCompany.attributes.name+"...",
                        });
                        self.$store.commit('setCardCompany',clientCompany);
                        setTimeout(function(){
                            self.$router.push({name: 'home'});
                        }, 1500);
                    }

                });

                // if (!this.sharing) {
                //     this.sharing = true;
                //     this.$store.dispatch('shareCards', ids).then(() => {
                //         this.$notify({
                //             group: 'notification',
                //             type: 'success',
                //             text: this.$ml.get('notification_share_card'),
                //         });
                //         this.sharing = false;
                //     }).catch((e) => {
                //         this.$notify({
                //             group: 'notification',
                //             type: 'error',
                //             title: this.$ml.get('notification_error_title'),
                //             text: this.$ml.get('notification_error_general'),
                //         });
                //         this.sharing = false;
                //         self.$checkTokenExp(e);
                //     })
                // }
            },
        },
        watch : {
            // masterAgencies(newVal){
            //     console.log('masterAgencies', newVal);
            // },
            searchString(newSearch) {
                clearTimeout(this.timeout);
                let self = this;
                self.timeout = setTimeout(() => {
                    self.doSearch(newSearch);
                }, 300);
            },
        }
    }
</script>

<style scoped>
    .per-page-select {
        width: 110px;
    }
    .hasCursor {
        cursor: pointer;
    }
    .suspended {
        opacity: 0.5;
    }

    .selected-agency-preview {
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
    }

    .company-logo {
        max-height: 16px;
        max-width: 40px;
    }

</style>
